import { RunSystemDetailDto, RunSystemEditDto } from './runsystem';

export const mapRunSystemDetailToEdit = (
  dto: RunSystemDetailDto
): RunSystemEditDto => ({
  id: dto.id,
  no: dto.no,
  name: dto.name,
  active: dto.active,
  productsRemixable: dto.productsRemixable,
  mixRunSystem: dto.mixRunSystem,
  description: dto.description,
  runSystemGrades: dto.runSystemGrades,
  archivingId: dto.archivingId
});
